import { showToastMessage } from '../services/ToastHelper';
import {
  ICloneConfigurationRequest,
  IDiffPackageRequest,
  IReadConfigurationRequest,
  IReadImageRequest,
  IReadSalesTextRequest,
} from '../../types/IApiTypes';
import { EMessageType, ProductApi, PunchoutApi } from '../data/Constants';
import axiosInstance from './AxiosClient';
import { t } from 'i18next';

export const searchConfiguration = async (configurationId: string) => {
  try {
    const request = {
      configurationId: configurationId,
      validate: true,
      include: {
        userAssignments: true,
        views: true,
      },
    };
    const response = await axiosInstance.post(PunchoutApi.Search, request);

    showToastMessage(EMessageType.Success, t('message.success.searchConfiguration'));
    return response;
  } catch (err) {
    const message =
      err?.status === 400 || err?.status === 404
        ? t('message.error.invalidConfiguration')
        : t('message.error.searchConfiguration');
    showToastMessage(EMessageType.Error, message);
    return err;
  }
};

export const readConfiguration = async (payload: IReadConfigurationRequest) => {
  try {
    const response = await axiosInstance.post(PunchoutApi.Configure, payload);
    showToastMessage(EMessageType.Success, t('message.success.getConfiguration'));
    return response.data;
  } catch (err) {
    showToastMessage(EMessageType.Error, t('message.error.getConfiguration'));
    return err;
  }
};

export const readSalesText = async (payload: IReadSalesTextRequest) => {
  try {
    const request = {
      packageCode: payload.packageCode,
      packageVersion: payload.packageVersion,
      productCodes: [payload.productId].concat(payload?.subModels ?? []),
      packageType: payload.packageType,
      include: {
        salesText: true,
      },
    };

    const response = await axiosInstance.post(PunchoutApi.ProductInfo, request, {
      headers: { skipLoader: true },
    });
    return response.data;
  } catch (err) {
    return err;
  }
};

export const readProductImage = async (payload: IReadImageRequest) => {
  try {
    const response = await axiosInstance.post(ProductApi.ReadImage, {
      packageType: payload.packageType,
      packageCode: payload.packageCode,
      productCode: payload.productCode,
    });
    return response.data;
  } catch (err) {
    showToastMessage(EMessageType.Error);
    return err;
  }
};

export const cloneConfiguration = async (payload: ICloneConfigurationRequest) => {
  try {
    const response = await axiosInstance.post(PunchoutApi.Clone, payload);
    return response;
  } catch (err) {
    showToastMessage(EMessageType.Error);
    return err;
  }
};

export const getDiffPackageVersion = async (payload: IDiffPackageRequest) => {
  try {
    const response = await axiosInstance.post(PunchoutApi.Diff, payload);
    return response;
  } catch (err) {
    showToastMessage(EMessageType.Error, t('message.error.getDiff'));
    return err;
  }
};
